/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
// CARD "Aurora" (modelo_card = 7): carrossel da home do modelo "Aurora". Cabeçalho da seção
// com título à esquerda e, à direita, "Ver todos" + setas redondas; trilho horizontal com
// scroll-snap NATIVO (sem lib): 3 cards no desktop, 2 no intermediário e ~1,15 no celular
// (o próximo "espiando").
// Card (15/10, layout pedido pelo Daniel a partir do card de zence.com.br): cartão branco de
// raio 14px com padding 15px e NADA sobre a foto; foto QUADRADA (1:1); quadro cinza de
// características em 2 colunas (ícone na cor de acento + "3 quartos", "1 suíte", "2 banheiros",
// "2 vagas", "137,73 m² área privativa", "170 m² área total", terreno); linha "Ref. X · Tipo N
// quartos"; bairro em negrito + cidade; título na cor de acento; rodapé com "Valor de venda" /
// "Valor de locação" + preço em negrito na cor de acento à esquerda e, à direita, coração de
// favorito + botão "Detalhes →".
// O card inteiro é link para a ficha (mesma URL/tracking do CardEditorial); preço/"Sob
// consulta"/marca d'água/flags seguem as mesmas regras do CardEditorial. Favoritar usa o
// include_favorito/delete_favorito do contexto (mesma lógica do CardApartament).
// TUDO VARIÁVEL: dados do imóvel/tenant; cores = site.corN com contraste calculado (acento =
// cor2 LEGÍVEL sobre o branco do card; botão "Detalhes" = cor2 sólida com texto calculado).
import Link from 'next/link';
import React, { useMemo, useRef } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import {
    ensureReadableTextColor,
    gera_titulo,
    isColorLight,
    marca_dagua,
    removerAcentos,
    toPrice,
} from '../../../utils/FunctionsGlobals';
import { textoNotranslate } from '../../pieces/idiomas/PrecoMoeda';
import { usePrecoMoeda } from '../../../utils/moedaSite';
import { getSafeImageSrc, preferGrandePhoto, PROPERTY_IMAGE_FALLBACK } from '../../../utils/image';
import { trackMetaEvent, metaPrecoParams } from '../../../utils/metaPixel';
import { appendCodsiteQuery } from '../../../utils/url';
import { hifenUrl } from '../../../utils/hifenUrl';
import { fontesMaioresDoSite } from '../../../utils/fontesMaioresPorSite';
import type { ModoEmpreendimentoCard } from '../../../utils/empreendimentoCard';
import { useAuth, useRegiaoHref } from '../../context/Info';
import type { CardSectionProps } from '../../registry/types';
import type { EmpreendimentosNoTrilho } from './CardAtelier';
import styles from './CardAurora.module.css';

// Ícones em traço (24px), herdam a cor do pai (cor de acento do tenant, aplicada inline).
const svgProps = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true };
const IconBed = () => (
    <svg {...svgProps}>
        <path d="M2 17v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" />
        <path d="M2 17h20M4 10V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3M13 10V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3" />
    </svg>
);
const IconSuite = () => (
    <svg {...svgProps}>
        <path d="M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3zM6 12V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2M6 20l-1 2M19 20l1 2" />
    </svg>
);
const IconBath = () => (
    <svg {...svgProps}>
        <path d="M5 11V5a2 2 0 0 1 2-2h1M12 3v4M9 7h6M12 7v4" />
        <path d="M3 11h18v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5v-2zM7 18l-1 3M17 18l1 3" />
    </svg>
);
const IconCar = () => (
    <svg {...svgProps}>
        <path d="M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13" />
        <path d="M5 13h14v4H5zM7 17v2M17 17v2" />
    </svg>
);
const IconArea = () => (
    <svg {...svgProps}>
        <path d="M3 3h18v18H3zM3 9h18M9 21V9" />
    </svg>
);
const IconLand = () => (
    <svg {...svgProps}>
        <path d="M3 20h18M4 20l3-9h10l3 9M9 11V7a3 3 0 0 1 6 0v4" />
    </svg>
);
const IconTag = () => (
    <svg {...svgProps}>
        <path d="M4 4h7l9 9-7 7-9-9V4z" />
        <circle cx="8" cy="8" r="1.2" />
    </svg>
);
const IconHouse = () => (
    <svg {...svgProps}>
        <path d="M3 11l9-7 9 7" />
        <path d="M5 10v10h5v-6h4v6h5V10" />
    </svg>
);
const IconArrowRight = () => (
    <svg {...svgProps} strokeWidth={2.2}>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
    </svg>
);
const IconArrow = ({ dir }: { dir: 'left' | 'right' }) => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {dir === 'left' ? <polyline points="15 18 9 12 15 6" /> : <polyline points="9 18 15 12 9 6" />}
    </svg>
);

export interface IAuroraCard {
    slide: any;
    site: any;
    codsite?: any;
    favorito: number[];
    /** cor2 do tenant SÓLIDA (fundo do botão "Detalhes") — e base do acento legível sobre o branco */
    corPreco: string;
    /** texto calculado para a cor2 sólida (texto do botão "Detalhes") */
    corPrecoTexto: string;
    /** /condominios (09/10): o slide é um EMPREENDIMENTO (utils/empreendimentoCard) — link e rótulo dele,
     *  "A partir de" como rótulo do preço, selo do empreendimento na linha do tipo, sem favorito. Opcional:
     *  sem a prop o card é o de sempre. */
    modoEmpreendimento?: ModoEmpreendimentoCard;
}

/** Área sem casas decimais sobrando: 170 → "170", 137.73 → "137,73" (NumeroFormatado força 2 casas). */
const area = (n: number) => Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const contagem = (n: number, um: string, varios: string) => `${n} ${n === 1 ? um : varios}`;

type Caracteristica = { chave: string; icone: React.ReactNode; texto: string; sufixo?: string };

export const AuroraCard: React.FC<IAuroraCard> = ({ slide, site, codsite, favorito, corPreco, corPrecoTexto, modoEmpreendimento: emp }) => {
    const { isMobile1, include_favorito, delete_favorito } = useAuth();
    // FOTO: a primeira do imóvel (array OU objeto único) > foto do empreendimento > fallback.
    const foto = useMemo(() => {
        const raw = Array.isArray(slide?.fotos) ? slide.fotos[0] : slide?.fotos?.url_foto ? slide.fotos : null;
        const url = (typeof raw === 'string' ? raw : raw?.url_foto) || slide?.empreendimento?.foto_destaque || PROPERTY_IMAGE_FALLBACK;
        const rawSrc = site?.marca_dagua?.ativada ? marca_dagua(url, site, isMobile1 ? 'm' : 'g') : preferGrandePhoto(url, !isMobile1);
        return getSafeImageSrc(rawSrc, PROPERTY_IMAGE_FALLBACK);
    }, [slide?.fotos, slide?.empreendimento?.foto_destaque, site?.marca_dagua?.ativada, isMobile1]);

    const renderPath = () => {
        const validationModel = slide?.venda ? 'venda' : slide?.aluguel ? 'aluguel' : 'venda';
        const hideCompanyInUrl = Number(site?.id) === 2551;
        const newPath = `/imoveis/${validationModel}/${
            slide?.cidade?.nome ? hifenUrl(slide?.cidade?.nome, site?.id).replaceAll('/', '-').replaceAll('?', '-') : '-'
        }/${slide?.bairro?.nome ? slide?.bairro?.nome.replaceAll('/', '-').replaceAll('?', '-') : '-'}/${
            site?.exibir_empreendimento && !hideCompanyInUrl ? slide?.empreendimento?.nome?.replaceAll('\n', '-').replaceAll('.', '-') || '-' : '-'
        }/${slide?.tipo?.nome ? hifenUrl(slide?.tipo?.nome, site?.id).replaceAll('/', '_') : '-'}/${
            slide?.referencia ? hifenUrl(slide?.referencia, site?.id).replaceAll('/', '_') : '-'
        }/imovel/${slide?.id}`.replaceAll(' ', '-');
        return appendCodsiteQuery(removerAcentos(newPath).toLowerCase(), codsite);
    };

    // area_tipo (AreaTipo) é a unidade do TERRENO; área privativa/total são sempre m² (#1070)
    const title = slide?.titulo ? slide?.titulo : gera_titulo(slide?.area_privativa > 0 || slide?.area_total > 0 ? { ...slide, area_tipo: 'm²' } : slide, site);
    // 21/10: preço na moeda do idioma (usePrecoMoeda) — fora do gate, o texto de sempre.
    const fmtPreco = usePrecoMoeda(site);
    const moeda = (preco: number) => {
        const simbolo = slide?.moeda_imovel && slide?.moeda_imovel != site?.moeda_tipo ? slide?.moeda_imovel : site?.moeda_tipo;
        const original = `${simbolo} ${toPrice(preco, 2)}`;
        return fmtPreco ? fmtPreco(preco, simbolo, original) : original;
    };
    const showVenda = Number(slide?.exibir_preco_venda && slide?.preco_venda > 0);
    const showLocacao = Number(slide?.aluguel > 0 && slide?.exibir_preco_locacao && slide?.preco_locacao > 0);
    const favoritado = Array.isArray(favorito) && favorito.indexOf(slide?.id) >= 0;

    // ACENTO: a cor2 do tenant quando é legível sobre o branco do card (título, preço, ícones,
    // coração); abaixo de 3:1 cai para o grafite — nunca chuta.
    const corAcento = ensureReadableTextColor(corPreco, '#ffffff', 3.0, '#1c2230', '#1c2230') || '#1c2230';

    // QUADRO DE CARACTERÍSTICAS (2 colunas): só o que o imóvel tem; vazio = quadro some.
    const caracteristicas: Caracteristica[] = [];
    if (slide?.dormitorios > 0) caracteristicas.push({ chave: 'quartos', icone: <IconBed />, texto: contagem(Number(slide.dormitorios), 'quarto', 'quartos') });
    if (slide?.suites > 0) caracteristicas.push({ chave: 'suites', icone: <IconSuite />, texto: contagem(Number(slide.suites), 'suíte', 'suítes') });
    if (slide?.banheiros > 0) caracteristicas.push({ chave: 'banheiros', icone: <IconBath />, texto: contagem(Number(slide.banheiros), 'banheiro', 'banheiros') });
    if (slide?.garagems > 0) caracteristicas.push({ chave: 'vagas', icone: <IconCar />, texto: contagem(Number(slide.garagems), 'vaga', 'vagas') });
    if (slide?.area_privativa > 0) caracteristicas.push({ chave: 'area_privativa', icone: <IconArea />, texto: `${area(slide.area_privativa)} m²`, sufixo: 'área privativa' });
    if (slide?.area_total > 0) caracteristicas.push({ chave: 'area_total', icone: <IconArea />, texto: `${area(slide.area_total)} m²`, sufixo: 'área total' });
    if (slide?.terreno > 0) caracteristicas.push({ chave: 'terreno', icone: <IconLand />, texto: `${area(slide.terreno)} ${slide?.area_tipo || 'm²'}`, sufixo: 'terreno' });

    // LINHA "Ref. X · Tipo N quartos" (empreendimento: o selo no lugar do tipo).
    const tipoRotulo = emp
        ? slide?.mini_banner_texto || 'Empreendimento'
        : [slide?.tipo?.nome, slide?.dormitorios > 0 ? contagem(Number(slide.dormitorios), 'quarto', 'quartos') : ''].filter(Boolean).join(' ');
    const bairro = slide?.bairro?.nome || '';
    const cidade = slide?.cidade?.nome || '';

    // PREÇOS: uma linha por finalidade ("Valor de venda" / "Valor de locação"); sem preço
    // exibível = "Sob consulta". Empreendimento: só o mínimo, com "A partir de" como rótulo.
    const precos: { rotulo: string; valor: string }[] = [];
    if (emp) {
        if (slide?.preco_venda > 0) precos.push({ rotulo: emp.precoPrefixo, valor: moeda(slide.preco_venda) });
    } else {
        if (slide?.venda == 1) precos.push({ rotulo: 'Valor de venda', valor: showVenda ? moeda(slide?.preco_venda) : 'Sob consulta' });
        if (slide?.aluguel == 1) precos.push({ rotulo: 'Valor de locação', valor: showLocacao ? `${moeda(slide?.preco_locacao)}/mês` : 'Sob consulta' });
    }

    const toggleFavorito = (e: React.MouseEvent) => {
        e.preventDefault(); // o card inteiro é link — não navega ao favoritar
        e.stopPropagation();
        if (!slide?.id) return;
        if (favoritado) delete_favorito(slide.id);
        else include_favorito(slide.id);
    };

    return (
        <Link
            prefetch={false}
            href={emp ? emp.href : renderPath()}
            onClick={(e) => {
                if (e.defaultPrevented || !slide?.id || emp) return;
                trackMetaEvent(site, 'ViewContent', {
                    content_ids: [String(slide.id)],
                    content_type: 'product',
                    content_name: [slide?.tipo?.nome, slide?.bairro?.nome, slide?.cidade?.nome].filter(Boolean).join(' - '),
                    content_category: slide?.categoria?.nome,
                    ...metaPrecoParams(slide?.preco_venda, slide?.preco_locacao),
                });
            }}
            className={styles.card}
            title={emp ? emp.rotulo : `${slide?.tipo?.nome || 'Imóvel'} ${slide?.venda ? 'à venda' : 'para alugar'} em ${slide?.cidade?.nome || ''}, Ref: ${slide?.referencia || ''}`}
        >
            <div className={styles.media}>
                <img
                    className={styles.foto}
                    src={foto}
                    alt={emp ? emp.rotulo : `${slide?.tipo?.nome || 'Imóvel'} ${slide?.venda ? 'à venda' : 'para alugar'} em ${slide?.bairro?.nome || ''} ${slide?.cidade?.nome || ''}`}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                        const img = e.currentTarget;
                        if (img.src !== PROPERTY_IMAGE_FALLBACK) img.src = PROPERTY_IMAGE_FALLBACK;
                    }}
                />
            </div>

            <div className={styles.dados}>
                {caracteristicas.length ? (
                    <ul className={styles.caracteristicas} aria-label="Características do imóvel">
                        {caracteristicas.map((c) => (
                            <li key={c.chave} className={styles.caracteristica}>
                                <span className={styles.icone} style={{ color: corAcento }}>
                                    {c.icone}
                                </span>
                                <small>
                                    {c.texto}
                                    {c.sufixo ? <span className={styles.sufixo}>{c.sufixo}</span> : null}
                                </small>
                            </li>
                        ))}
                    </ul>
                ) : null}

                {slide?.referencia || tipoRotulo ? (
                    <div className={styles.linhaRef}>
                        {slide?.referencia ? (
                            <span className={styles.meta}>
                                <span className={styles.icone} style={{ color: corAcento }}>
                                    <IconTag />
                                </span>
                                Ref. {slide?.referencia}
                            </span>
                        ) : null}
                        {tipoRotulo ? (
                            <span className={styles.meta}>
                                <span className={styles.icone} style={{ color: corAcento }}>
                                    <IconHouse />
                                </span>
                                {tipoRotulo}
                            </span>
                        ) : null}
                    </div>
                ) : null}

                {bairro || cidade ? (
                    <div className={styles.local}>
                        {bairro ? <b>{bairro}</b> : null}
                        {bairro && cidade ? ', ' : null}
                        {cidade ? <small>{cidade}</small> : null}
                    </div>
                ) : null}

                <h3 className={styles.titulo} style={{ color: corAcento }}>
                    {title}
                </h3>

                <div className={styles.rodape}>
                    <div className={styles.precos}>
                        {precos.map((p) => (
                            <div key={p.rotulo} className={styles.precoItem}>
                                <small>{p.rotulo}</small>
                                <b style={{ color: corAcento }}>{textoNotranslate(!!fmtPreco, p.valor)}</b>
                            </div>
                        ))}
                    </div>
                    <div className={styles.acoes}>
                        {emp ? null : (
                            <button
                                type="button"
                                className={styles.favorito}
                                style={{ color: corAcento }}
                                aria-label={favoritado ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
                                aria-pressed={favoritado}
                                title={favoritado ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
                                onClick={toggleFavorito}
                            >
                                {favoritado ? <FaHeart aria-hidden="true" /> : <FaRegHeart aria-hidden="true" />}
                            </button>
                        )}
                        <span className={styles.detalhes} style={{ background: corPreco, color: corPrecoTexto }}>
                            Detalhes
                            <IconArrowRight />
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

/**
 * HOME "Empreendimentos" no MESMO trilho dos carrosséis de imóveis (components/carousel/ventures/VenturesAurora),
 * igual ao Atelier: cada slide é um empreendimento (utils/empreendimentoCard), `modos` traz o
 * modoEmpreendimento de cada um pelo id e o "Ver todos" já chega pronto (/condominios).
 */
const CardAurora: React.FC<CardSectionProps & { empreendimentos?: EmpreendimentosNoTrilho }> = ({ slides, site, codsite, url, cores, title, favorito, is_mobile, empreendimentos: emp }) => {
    const withRegiao = useRegiaoHref();
    // Ordem como vem do CRM (determinística: o mesmo HTML no servidor e no cliente).
    // No celular, os 8 primeiros — mesmo teto do CardEditorial.
    const data = useMemo(() => (is_mobile ? (slides || []).slice(0, 8) : slides || []), [slides, is_mobile]);

    const corFundo = cores?.cor_fundo ? cores?.cor_fundo : site?.cor5 || '#f6f7f9';
    const corTitulo = ensureReadableTextColor(isColorLight(corFundo) ? site?.cor11 : site?.cor13, corFundo || '#ffffff') || '#1c2230';
    const corAcento = ensureReadableTextColor(site?.cor2, corFundo, 3.0, corTitulo, corTitulo) || corTitulo;
    // botão "Detalhes" do card: cor2 sólida com texto calculado (o acento sobre o branco é calculado no card).
    const corPreco = site?.cor2 || '#1c2230';
    const corPrecoTexto = ensureReadableTextColor(isColorLight(corPreco) ? site?.cor11 : site?.cor13, corPreco) || '#ffffff';

    const trilhoRef = useRef<HTMLDivElement | null>(null);
    const rolar = (sentido: 1 | -1) => {
        const el = trilhoRef.current;
        if (!el) return;
        const primeiro = el.firstElementChild as HTMLElement | null;
        const passo = primeiro ? primeiro.offsetWidth + 20 : el.clientWidth * 0.8;
        el.scrollBy({ left: sentido * passo, behavior: 'smooth' });
    };

    // MULTI-FILIAIS: o "Ver todos" leva a filial ativa (os cards apontam para a ficha, que
    // NUNCA ganha ?regiao=).
    const verTodosUrl = emp ? emp.verTodosHref : url ? withRegiao(appendCodsiteQuery(url, codsite)) : '';
    const [variosItens, rotuloItens] = emp ? ['empreendimentos', 'Empreendimentos'] : ['imóveis', 'Imóveis'];

    if (!data.length) return null;

    return (
        <section className={`${styles.secao} ${fontesMaioresDoSite(site) ? styles.fontesMaiores : ''}`} style={{ background: corFundo, color: corTitulo }}>
            <div className={styles.cabecalho}>
                <h2 className={styles.tituloSecao}>{title}</h2>
                <div className={styles.controles}>
                    {verTodosUrl ? (
                        <a href={verTodosUrl} className={styles.verTodos} style={{ color: corAcento }} data-no-quicklink data-no-instant data-no-prefetch rel={emp ? undefined : 'nofollow'}>
                            {emp ? emp.verTodosRotulo : 'Ver todos'}
                            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </a>
                    ) : null}
                    <button type="button" className={styles.seta} aria-label={`${rotuloItens} anteriores`} onClick={() => rolar(-1)}>
                        <IconArrow dir="left" />
                    </button>
                    <button type="button" className={styles.seta} aria-label={`Próximos ${variosItens}`} onClick={() => rolar(1)}>
                        <IconArrow dir="right" />
                    </button>
                </div>
            </div>

            <div ref={trilhoRef} className={styles.trilho}>
                {data.map((slide: any) => (
                    <div className={styles.item} key={slide?.id}>
                        <AuroraCard slide={slide} site={site} codsite={codsite} favorito={favorito || []} corPreco={corPreco} corPrecoTexto={corPrecoTexto} modoEmpreendimento={emp?.modos.get(Number(slide?.id))} />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CardAurora;
